<template>
    <div>
        <div v-if="$root.loading" class="loading">در حال بارگذاری...</div>

        <div class="row">
            <div class="col-12">
                <template v-if="cart">
                    <template v-if="cart.products.length">

                        <table class="table table-sm">
                            <thead>
                            <tr>
                                <th style="width: 75px"></th>
                                <th class="text-right">نام کالا</th>
                                <th class="text-right">تخفیف</th>
                                <th class="text-right">قیمت</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="product in cart.products">
                                <td>
                                    <a :href="product.link" target="_blank" :title="product.name_fa">
                                        <img :alt="product.name_fa"
                                             width="75" height="53"
                                             :src="product.image"
                                             :title="product.name_fa" class="sidebar-cart-image border">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        <a :href="product.link" target="_blank" class="text-dark">
                                            {{ product.name_fa }}
                                        </a>
                                    </div>
                                    <div class="text-sm text-secondary">{{ product.name_en }}</div>
                                </td>
                                <td class="text-right num-fa">
                                    {{ product.discount.toLocaleString() }}
                                </td>
                                <td class="text-right num-fa">
                                    {{ product.price.toLocaleString() }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                                <td class="text-right num-fa">
                                    {{ cart.discount().toLocaleString() }}
                                </td>
                                <td class="text-right num-fa">
                                    {{ cart.amount().toLocaleString() }}
                                </td>
                            </tr>
                            <tr class="font-weight-bold text-dark">
                                <td colspan="3">مبلغ قابل پرداخت</td>
                                <td class="num-fa">
                                    {{ cart.total().toLocaleString() }}
                                    تومان
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </template>
                    <template v-else>
                        <div class="alert alert-info">
                            <i class="fa fa-info-circle ml-1"></i>
                            سبد خرید خالیست!
                            ابتدا از
                            <a :href="$root.baseURL + 'products'" title="فروشگاه فایلکده"> فروشگاه </a>
                            محصولی را انتخاب و به سبد خرید بیافزایید.
                        </div>
                    </template>
                </template>
            </div>
            <div v-if="cart && cart.products.length" class="col-12">
                <hr />
                <div class="row">

                    <div class="form-group col-xx-4 col-el-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                        <label for="name">نام و نام خانوادگی<span
                            class="text-danger">*</span></label>
                        <input type="text" :class="['form-control', (errors['name'] ? 'is-invalid' : '')]"
                               id="name" v-model="name">
                        <span v-if="errors['name']" class="text-danger">{{ errors['name'][0] }}</span>
                    </div>

                    <div class="form-group col-xx-4 col-el-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                        <label for="email">ایمیل <span class="text-danger">*</span></label>
                        <input type="text" :class="['form-control en', (errors['email'] ? 'is-invalid' : '')]"
                               id="email" v-model="email">
                        <span v-if="errors['email']" class="text-danger">{{ errors['email'][0] }}</span>
                    </div>


                    <div class="form-group col-xx-4 col-el-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                        <label for="mobile">موبایل <span class="text-danger">*</span></label>
                        <input type="text" :class="['form-control num-fa', (errors['mobile'] ? 'is-invalid' : '')]"
                               id="mobile" placeholder="موبایل (مثال: *********09)" v-model="mobile">
                        <span v-if="errors['mobile']" class="text-danger">{{ errors['mobile'][0] }}</span>
                    </div>


                    <!--
                    <div class="form-group col-xx-4 col-el-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12" style="display: none;">
                        <label for="payment">روش پرداخت <span class="text-danger">*</span></label>
                        <select class="form-control" name="payment" id="payment">
                            <option
                                value="online" selected="selected">
                                درگاه پرداخت آنلاین
                            </option>
                        </select>
                    </div>
                    -->
                </div>
                <div>
                    <hr />
                    <button class="btn btn-success ml-1" name="save" @click.prevent="submit">
                        <i class="fa fa-save ml-1"></i>
                        ثبت و پرداخت
                    </button>
                    <a class="btn btn-outline-danger" :href="$root.baseURL + 'products'">
                        افزودن کالاهای بیشتر...</a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'cart',
    components: {},
    data() {
        let self = this;

        return {
            errors: [],
            name: '',
            email: '',
            mobile: '',
            order_id: null,
        };
    },
    props: {
        userInfo: {
            type: Object,
            required: true,
        }
    },
    computed: {
        cart() {
            return this.$root.cart;
        }
    },
    watch: {},
    methods: {
        clearErrors() {
            let self = this;

            window.setTimeout(function () {
                self.errors = [];
            }, 6000);
        },
        readState() {
            let key = this.$root.baseURL + 'cart';
            let st = JSON.parse(localStorage.getItem(key));
            if (st) {
                this.name = st.name;
                this.email = st.email;
                this.mobile = st.mobile;
            }
        },
        writeState() {
            let key = this.$root.baseURL + 'cart';
            let st = {
                name: this.name,
                email: this.email,
                mobile: this.mobile,
            };
            localStorage.setItem(key, JSON.stringify(st));
        },
        submit(e) {
            let self = this;

            //console.log(e);
            //console.log(self.cart.products);

            self.writeState();

            let product_ids = [];
            self.cart.products.forEach(function (el) {
                product_ids.push(el.id);
            });

            self.$root.loading = true;
            axios.post(self.$root.baseURL + 'orders', {
                name: self.name,
                email: self.email,
                mobile: self.mobile,
                product_ids: product_ids,
                order_id: self.order_id,
            })
                .then((response) => {
                    self.$root.loading = false;
                    self.$root.toastr.success(response.data.message);
                    localStorage.clear();

                    window.location = response.data.link;

                    //$('#guestCommentModal').modal('hide');
                    //
                    //self.message = response.data.message;
                    //self.show = false;
                    //
                    //$('#orderForm').submit();
                })
                .catch((error) => {
                    self.$root.onError(error);


                    if (error.response.status === 422) {
                        self.errors = error.response.data.errors;
                        self.clearErrors();
                    }


                    if (error.response.data.order_id) {
                        self.order_id = error.response.data.order_id;
                    }


                    if (error.response.data.refresh) {
                        window.setTimeout(function () {
                            window.location = window.location;
                        }, error.response.data.refresh);
                    }
                });
        }
    },
    mounted() {
        this.readState();
        //window.C = this;
    }
}
</script>
